import { ref } from 'vue'

export const progresso = ref(0)
export const visivel = ref(false)

let temporizador: ReturnType<typeof setInterval> | null = null
let ocultarTimeout: ReturnType<typeof setTimeout> | null = null

export function iniciarPreloader() {
  if (ocultarTimeout) clearTimeout(ocultarTimeout)
  if (temporizador) clearInterval(temporizador)

  visivel.value = true
  progresso.value = 0

  temporizador = setInterval(() => {
    progresso.value += (90 - progresso.value) * 0.1
  }, 100)
}

export function concluirPreloader() {
  if (temporizador) clearInterval(temporizador)

  progresso.value = 100

  ocultarTimeout = setTimeout(() => {
    visivel.value = false
    progresso.value = 0
  }, 250)
}
